'use client'

import React, { FunctionComponent, useMemo } from 'react'
import useVisibilityChange from '@/hooks/useVisibilityChange'
import ThemeContext, { VenueContext } from './ThemeContext'
import useIdleTimerTool from '@/hooks/useIdleTimerTool'
import useIsMobile from '@/hooks/useIsMobile'
import useStaleStateReset from '@/hooks/useStaleStateReset'

type Props = {
  children: React.ReactNode
  isAppView: boolean
}

const ThemeProvider: FunctionComponent<Props> = ({
  isAppView,
  children,
}: Props) => {
  const mobile = useIsMobile()
  useVisibilityChange()
  useIdleTimerTool()
  useStaleStateReset()

  const value: VenueContext = useMemo(() => ({
    mobile,
    appView: isAppView,
  }), [mobile, isAppView])

  return (
    <ThemeContext.Provider value={value}>
      <div className="themed">
        {children}
      </div>
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
